// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"8dfcfcf8","252":"594dc2c2","320":"02cfa396","787":"c1112931"}[chunkId] + ".chunk.js";
};